import React, {Suspense, useEffect, useState} from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import Dashboard from 'src/screens/Dashboard/Dashboard';
import MediaLibrary from './screens/MediaLibrary/MediaLibrary';
import TransformationV2 from './screens/TransformationV2/TransformationV2';
import {LoginCallbackComponent, LoginComponent, LogoutComponent} from 'src/screens/Login/login';
import {Layout} from './layout';
import {SettingsLayout} from './screens/settings/Layout';
import {Profile} from './screens/settings/profile/Profile';
import InvoiceDetails from './screens/settings/billing/Invoices';
import BillingDetails from './screens/settings/billing/BillingDetails';
import PixelPlansScreen from './screens/settings/plans/PixelPlansScreen';
import ImageDetails from './screens/ImageDetails/ImageDetails';
import {QuickTrialScreen} from './screens/TransformationV2/QuickTrialScreen';
import {ApiKeyScreen} from './screens/settings/apikey/ApiKeyScreen';
import {UserManagementScreen} from './screens/settings/users/UserManagementScreen';
import {UserInvitationScreen} from './screens/settings/users/UserInvitationScreen';
import {AuthProvider} from './AuthProvider';
import RemoteStorageScreen from './screens/RemoteStorage/screen';
import CustomDomainsListScreen from './screens/CustomDomain/list';
import CustomDomainScreenLayout from './screens/CustomDomain/base';
import CustomDomainVerify from './screens/CustomDomain/verify';
import CustomDomainSettings from './screens/CustomDomain/settings';
import CustomDomainAdd from './screens/CustomDomain/add';
import CustomDomainDelete from './screens/CustomDomain/delete';
import {SecurityScreen} from './screens/settings/security/SecurityScreen';
import BulkTransformation from './screens/BulkTransformation/BulkTransformation';
import Wallet from './screens/settings/wallet';
import TshirtView from './module/tshirt-configurator/src';
import {CommonSpinLoader} from './ui-components/loaders';
const Studio = React.lazy(() => import('./module/pixel-design-studio/pixel_studio/Studio'));

function App() {
    return (
        <Suspense fallback={<CommonSpinLoader />}>
            <BrowserRouter basename={'dashboard'}>
                <AuthProvider>
                    {/*<FontProvider>*/}
                    <Routes>
                        <Route path='/_login' element={<LoginComponent />} />
                        <Route path='/_callback' element={<LoginCallbackComponent />} />
                        <Route path='/logout' element={<LogoutComponent />} />

                        <Route path='/' element={<Layout />}>
                            <Route index element={<Dashboard />} />
                            <Route path='/media-library/:folderName?' element={<MediaLibrary />} />
                            <Route path={'/wallet'} element={<Wallet />} />
                            <Route path=':orgUid/image-details/:fileUid' element={<ImageDetails />} />
                            <Route path='/remote-storage' element={<RemoteStorageScreen />} />
                            <Route path={'/domains'} element={<CustomDomainScreenLayout />}>
                                <Route index element={<CustomDomainsListScreen />} />
                                <Route path='add' element={<CustomDomainAdd />} />
                                <Route path='verify/:hostname' element={<CustomDomainVerify />} />
                                <Route path='settings/:hostname' element={<CustomDomainSettings />} />
                                <Route path={'delete/:hostname'} element={<CustomDomainDelete />} />
                            </Route>
                        </Route>
                        <Route path='/settings' element={<SettingsLayout />}>
                            <Route index element={<Navigate to={'/settings/profile'} replace={true} />} />
                            <Route path={'/settings/profile'} element={<Profile />} />
                            <Route path={'/settings/plans'} element={<PixelPlansScreen />}>
                                <Route path={'/settings/plans/start/:planId'} element={<PixelPlansScreen />} />
                            </Route>
                            <Route path={'/settings/billing'} element={<BillingDetails />} />
                            <Route path={'/settings/invoices'} element={<InvoiceDetails />} />
                            <Route path={'/settings/keys'} element={<ApiKeyScreen />} />
                            <Route path={'/settings/wallet'} element={<Wallet />} />
                            <Route path={'/settings/users'} element={<UserManagementScreen />} />
                            <Route path={'/settings/invitations'} element={<UserInvitationScreen />} />
                            <Route path={'/settings/security'} element={<SecurityScreen />} />
                        </Route>
                        <Route path='/transformation/:fileUid' element={<TransformationV2 />} />
                        <Route path='/pixelstudio' element={<Studio />} />
                        <Route path='/tshirt' element={<TshirtView />} />
                        <Route path='/trial/:fileUid?' element={<QuickTrialScreen />} />
                        <Route path='/bulkTransformation/:fileUids' element={<BulkTransformation />} />
                    </Routes>
                    {/*</FontProvider>*/}
                </AuthProvider>
            </BrowserRouter>
        </Suspense>
    );
}

export default App;
